import StickyPageTitle from "../../Components/Header/Sticky/index.js";
import { useAnalyticsPage, KpiCard, ConsentBar, IndustryBenchmarkNote } from "./_shared.js";
import { IconShieldCheck, IconBarChart } from "./Icons.js";
import "./Analytics.css";

export default function AnalyticsConsent() {
    document.title = "Consent | Site Analytics";

    const {
        domain, hasDomain, getLastDays, setLastDays, fromDate, setFromDate, toDate, setToDate,
        data, loading, error, showData,
    } = useAnalyticsPage();

    return (
        <div style={{ flex: "1", minWidth: 0 }}>
            <StickyPageTitle
                title="Consent"
                numberofDays={setLastDays}
                getLastDays={getLastDays}
                fromDate={fromDate}
                toDate={toDate}
                setFromDate={setFromDate}
                setToDate={setToDate}
            />
            <div className="dashboard-content">
                <div className="sa-page">
                    {!hasDomain && (
                        <p className="sa-notice">Select a domain in the header to view consent data.</p>
                    )}
                    {hasDomain && loading && <p className="sa-notice">Loading&hellip;</p>}
                    {hasDomain && error && <p className="sa-notice sa-notice--error">{error}</p>}
                    {hasDomain && !loading && data?.noSiteKey && (
                        <p className="sa-notice">No analytics set up for this domain yet.</p>
                    )}
                    {hasDomain && !loading && data?.noData && (
                        <p className="sa-notice">No data for the selected period.</p>
                    )}

                    {showData && (() => {
                        const { stat, func, adv } = data.consent;
                        const total = data.totals.total;
                        const statRate = stat.yes + stat.no > 0
                            ? Math.round((stat.yes / (stat.yes + stat.no)) * 100)
                            : 0;
                        const funcRate = func.yes + func.no > 0
                            ? Math.round((func.yes / (func.yes + func.no)) * 100)
                            : 0;
                        const advRate = adv.yes + adv.no > 0
                            ? Math.round((adv.yes / (adv.yes + adv.no)) * 100)
                            : 0;
                        return (
                            <div className="sa-consent-page-grid">

                                <KpiCard className="sa-cg-kpi1"
                                    icon={<IconShieldCheck />}
                                    label="Statistics consent"
                                    value={statRate + "%"}
                                    sub={`${stat.yes.toLocaleString("de-DE")} yes · ${stat.no.toLocaleString("de-DE")} no`}
                                    variant={statRate < 20 ? "warn" : null}
                                >
                                    <IndustryBenchmarkNote benchmark={data.industryBenchmark} actualPct={statRate} />
                                </KpiCard>
                                <KpiCard className="sa-cg-kpi2"
                                    icon={<IconShieldCheck />}
                                    label="Functional consent"
                                    value={funcRate + "%"}
                                    sub={`${func.yes.toLocaleString("de-DE")} yes · ${func.no.toLocaleString("de-DE")} no`}
                                    variant={funcRate < 20 ? "warn" : null}
                                />
                                <KpiCard className="sa-cg-kpi3"
                                    icon={<IconShieldCheck />}
                                    label="Advertising consent"
                                    value={advRate + "%"}
                                    sub={`${adv.yes.toLocaleString("de-DE")} yes · ${adv.no.toLocaleString("de-DE")} no`}
                                    variant={advRate < 20 ? "warn" : null}
                                />
                                <KpiCard className="sa-cg-kpi4"
                                    icon={<IconBarChart />}
                                    label="Total events"
                                    value={total.toLocaleString("de-DE")}
                                    sub={`${data.totals.minimal.toLocaleString("de-DE")} minimal · ${data.totals.full.toLocaleString("de-DE")} full`}
                                />

                                <div className="sa-panel sa-cg-bars">
                                    <h3 className="sa-panel__title"><IconShieldCheck className="sa-icon" /> Consent rates</h3>
                                    <div className="sa-consent-list">
                                        <ConsentBar label="Statistics"  yes={stat.yes} no={stat.no} />
                                        <ConsentBar label="Functional"  yes={func.yes} no={func.no} />
                                        <ConsentBar label="Advertising" yes={adv.yes}  no={adv.no}  />
                                    </div>

                                    <div className="sa-panel__divider" />

                                    <h3 className="sa-panel__sub-title">Event breakdown</h3>
                                    <div className="sa-consent-list">
                                        <div className="sa-consent-row">
                                            <span className="sa-consent-row__label">With consent</span>
                                            <div className="sa-bar">
                                                <div className="sa-bar__seg"
                                                    style={{
                                                        width: total > 0 ? Math.round((data.totals.full / total) * 100) + "%" : "0%",
                                                        background: "rgba(74,222,128,0.75)",
                                                    }}
                                                    title={`Full: ${data.totals.full}`}
                                                />
                                            </div>
                                            <span className="sa-consent-row__pct">
                                                {total > 0 ? Math.round((data.totals.full / total) * 100) : 0}%
                                            </span>
                                        </div>
                                        <div className="sa-consent-row">
                                            <span className="sa-consent-row__label">Minimal only</span>
                                            <div className="sa-bar">
                                                <div className="sa-bar__seg"
                                                    style={{
                                                        width: total > 0 ? Math.round((data.totals.minimal / total) * 100) + "%" : "0%",
                                                        background: "rgba(192,159,83,0.55)",
                                                    }}
                                                    title={`Minimal: ${data.totals.minimal}`}
                                                />
                                            </div>
                                            <span className="sa-consent-row__pct">
                                                {total > 0 ? Math.round((data.totals.minimal / total) * 100) : 0}%
                                            </span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        );
                    })()}
                </div>
            </div>
        </div>
    );
}
